import axios from 'axios'
import {OptionModel, ResponseObjectPaginated, ResponseObject, ResponseCRUD} from '../model'

const BASEURL = process.env.REACT_APP_DEV_API_CENTRAL_URL
export function getOption(dto: any, page: number, size: number = 10) {
  return axios.post<ResponseObjectPaginated<OptionModel[]>>(
    `${BASEURL}/profile/getPermissions?pageNumber=${page}&size=${size}`,
    dto,
  )
}

export function getOptionFather(page: number, id: number) {
  return axios.post<ResponseObjectPaginated<OptionModel[]>>(
    `${BASEURL}/profile/getPermissions?pageNumber=${page}&isChildren=${true}&size=100`,
    {aplicacionId: id},
  )
}

export function getOptionById(dto: any | undefined) {
  return axios.get<ResponseObject<OptionModel>>(
    `${BASEURL}/profile/getPermissionsInformationById?vistaPermisoId=${dto}`,
  )
}

export function createOption(dto: OptionModel) {
  return axios.post<ResponseCRUD>(`${BASEURL}/profile/createPermission`, dto)
}

export function updateOption(dto: OptionModel) {
  return axios.put<ResponseCRUD>(`${BASEURL}/profile/updatePermission`, dto)
}

export function deleteOption(dto: any) {
  return axios.delete<ResponseCRUD>(`${BASEURL}/profile/deletePermission?id=${dto}`)
}

// PERMISOS

export function getPermissionByOption(page: number, id: any, size: number = 10) {
  return axios.get<ResponseObjectPaginated<OptionModel[]>>(
    `${BASEURL}/profile/getAllOptionsByPermission?vistaPermisoId=${id}&pageNumber=${page}&size=${size}`,
  )
}

export function savePermissionByOption(dto: any) {
  return axios.post<ResponseCRUD>(`${BASEURL}/profile/assingOptionsToPermission`, dto)
}
export function editPermissionByOption(dto: any) {
  return axios.post<ResponseCRUD>(`${BASEURL}/profile/editOption`, dto)
}
export function deletePermissionByOption(dto: any) {
  return axios.post<ResponseCRUD>(`${BASEURL}/profile/deleteOptionsToPermission`, dto)
}

export function getViwPermissionByOption(
  applicationId: string,
  profileId: string = '',
  page: number,
  id: any,
) {
  return axios.get<ResponseObjectPaginated<OptionModel[]>>(
    `${BASEURL}/profile/getViewOptionsPermissions?aplicacionId=${applicationId}&vistaPermisoId=${id}&perfilId=${profileId}&pageNumber=${page}&size=100`,
  )
}
